import { __read } from "tslib";
import { get } from 'lodash-es';
import React from 'react';
import { useMutation, useQuery } from 'react-apollo';
import { usePermissions } from '@marvelapp/marvel-3-application';
import { Box, Text } from '@marvelapp/ui';
import EditableText from '../EditableText';
import { Modal } from '../Modal';
import Page from '../Page';
import { ManagePeople, PersonButton } from '../People';
import { showErrorNotification } from '../ToastContainer';
import { GET_COMPANY_USERS, GET_GROUP_BY_PK, GET_GROUP_MEMBERS, UPDATE_GROUP_NAME, } from './graphql';
import useAddMembersToTeamMutation from './hooks/useAddMembersToTeamMutation';
import useRemoveMembersFromTeamMutation from './hooks/useRemoveMembersFromTeamMutation';
export default function ManageGroup(_a) {
    var match = _a.match;
    var teamPk = parseInt(match.params.pk, 10);
    var _b = __read(useAddMembersToTeamMutation(), 1), addMembersToTeam = _b[0];
    var _c = __read(useRemoveMembersFromTeamMutation(), 1), removeMembersFromTeam = _c[0];
    var queries = [
        {
            name: 'Members',
            query: GET_GROUP_MEMBERS,
            dataConnection: 'team.members',
            variables: {
                teamPk: teamPk,
            },
            onRemove: function (member) {
                removeMembersFromTeam({
                    teamPk: teamPk,
                    emails: [member.email],
                });
            },
        },
    ];
    var searchQueries = [
        {
            name: 'Members',
            query: GET_COMPANY_USERS,
            dataConnection: 'user.company.members',
            variables: {
                teamPk: teamPk,
            },
            searchVariable: 'username',
            onAdd: function (member) {
                return addMembersToTeam({
                    teamPk: teamPk,
                    members: [member],
                });
            },
            isCollaborator: function (_a) {
                var isTeamMember = _a.isTeamMember;
                return isTeamMember;
            },
        },
    ];
    var data = useQuery(GET_GROUP_BY_PK, {
        variables: { pk: teamPk },
    }).data;
    var group = get(data, 'team');
    var _d = __read(useMutation(UPDATE_GROUP_NAME), 1), updateGroupName = _d[0];
    var permissions = usePermissions();
    var inviteUsersUrl = permissions.canInvitePeopleToCompany()
        ? "/company/group/".concat(match.params.pk, "/invite")
        : null;
    var renderPersonRowButtonComponent = function (_a) {
        var node = _a.node, onRemove = _a.onRemove, isLoading = _a.isLoading, isDisabled = _a.isDisabled, ownerPk = _a.ownerPk;
        var addedViaTeam = node.addedViaTeam, pk = node.pk;
        var isOwner = pk === ownerPk;
        return (React.createElement(PersonButton, { badgeText: isOwner ? 'Owner' : addedViaTeam && 'Remove', badgeTooltip: isOwner && "The owner can't be removed", buttonKind: "ghostDanger", buttonText: "Remove", isDisabled: isDisabled, isLoading: isLoading, onButtonClick: function () { return onRemove(node); } }));
    };
    var renderSearchButton = function (_a) {
        var isCollaborator = _a.isCollaborator, node = _a.node, onAdd = _a.onAdd, isLoading = _a.isLoading, isDisabled = _a.isDisabled;
        return (React.createElement(PersonButton, { badgeText: isCollaborator && 'Added', badgeTooltip: isCollaborator && 'This person is already a collaborator', buttonKind: "green", buttonText: "Add", isDisabled: isDisabled, isLoading: isLoading, onButtonClick: function () { return onAdd(node); } }));
    };
    return (React.createElement(Page, { title: "Create group" },
        React.createElement(Modal, { closeLink: getCloseLink(match) },
            React.createElement(Box, { borderBottom: "1px solid", borderColor: "smoke", pb: 4 },
                React.createElement(Box, { display: "inline-block" },
                    React.createElement(EditableText, { fontWeight: 600, onSaveValue: function (newGroupName) {
                            var toastId = 'updateGroupName';
                            updateGroupName({
                                variables: { pk: teamPk, newName: newGroupName },
                            }).catch(function () {
                                showErrorNotification({
                                    toastId: toastId,
                                    content: "Your group's name couldn't be updated. Please try again.",
                                });
                            });
                        }, value: group && group.name }),
                    React.createElement(Text, { fontSize: 14, marginTop: 1 }, "Add and remove people from your team here"))),
            React.createElement(ManagePeople, { canEdit: true, canSearch: true, getOwnerPk: function (queryData) { return get(queryData, 'team.owner.pk'); }, inviteUsersUrl: inviteUsersUrl, queries: queries, renderPersonRowButtonComponent: renderPersonRowButtonComponent, renderSearchButton: renderSearchButton, searchQueries: searchQueries }))));
}
function getCloseLink(match) {
    var _a = match.params, projectPk = _a.projectPk, folderId = _a.id, userTestId = _a.userTestId;
    if (folderId) {
        return "/folder/".concat(folderId, "/share");
    }
    if (userTestId) {
        return "/user-test/".concat(userTestId, "/project/").concat(projectPk, "/share");
    }
    if (projectPk) {
        return "/project/".concat(projectPk, "/share");
    }
    return '/company/groups';
}
